import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { useDispatch, shallowEqual, useSelector } from 'react-redux';

import { Tappable } from '@common/ui/general';
import { PROGRAM_OPTIONS } from '~referral/utils/constants';
import { REFERRAL_TRACKING } from '@referrals/utils/trackingEvents';
import { behaviouralActivityTextMap } from '@referrals/utils/constants';
import { toggleReferralProgramSelect } from '@referrals/stores/home';
import analytics from '@referrals/analytics';
import referralAPI from '@referrals/api/referral';

const { selectedPreferredProgram } = behaviouralActivityTextMap;

const ReferralProgramOptions = ({ className }) => {
  const dispatch = useDispatch();
  const [selectedProgram, setSelectedProgram] = useState(null);
  const { showReferralProgramSelect } = useSelector(state => ({
    showReferralProgramSelect: state?.home?.showReferralProgramSelect
    || state?.referral?.callback?.showReferralProgramSelect,
  }), shallowEqual);

  const handleProgramSelect = useCallback((program) => {
    setSelectedProgram(program.value);
    referralAPI.behaviouralData(
      selectedPreferredProgram, [program.value],
    );

    analytics.view(
      REFERRAL_TRACKING.userPreferredProgramSelectedClick,
      'User Preferred Program Section',
    );

    setTimeout(() => {
      dispatch(toggleReferralProgramSelect(false));
    }, 3000);
  }, [dispatch]);

  if (!showReferralProgramSelect) return null;

  return (
    <div className={classNames('referral-program-options', className)}>
      <div className="referral-program-options__container">
        <div className="referral-program-options__heading">
          Please select the program you to which your are referring
        </div>
        <div className="referral-program-options__values">
          {PROGRAM_OPTIONS.map((program, index) => (
            <Tappable
              className={`referral-program-options__value ${
                selectedProgram === program.value ? 'selected' : ''
              }`}
              key={index}
              onClick={() => handleProgramSelect(program)}
            >
              {program.name}
              { program.isNew && (
                <div className="referral-program-options__new-label">
                  New
                </div>
              )}
            </Tappable>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReferralProgramOptions;
